import { ItemType } from '@vista-digital/ocapi-types/v1';
import { getFetchedDataPayload } from '../../../../utils/fetched-data/get-fetched-data-payload';
import { salesDataDomainStore } from '../../store';
import { isRecipeItemSupported } from '../../utils/items/recipe-item-utils';
export const getItemById = (itemId) => {
    const item = getFetchedDataPayload(salesDataDomainStore.data.itemsById[itemId]);
    if ((item === null || item === void 0 ? void 0 : item.type) !== ItemType.Recipe)
        return item;
    // TODO: Remove this mapping when recipe items are better supported. #291340
    return isRecipeItemSupported(item) ? Object.assign(Object.assign({}, item), { type: ItemType.Normal }) : item;
};
